module.exports = __webpack_public_path__ + "img/product.31236e2f.png";